import { render, staticRenderFns } from "./PhotoMagic.vue?vue&type=template&id=4fa114be&scoped=true"
import script from "./PhotoMagic.vue?vue&type=script&lang=js"
export * from "./PhotoMagic.vue?vue&type=script&lang=js"
import style0 from "./PhotoMagic.vue?vue&type=style&index=0&id=4fa114be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa114be",
  null
  
)

export default component.exports